import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export const research = [
  {
    slug: 'cuttlebot',
    title: 'cuttlebot',
    description: 'biomimetic robot inspired by cephalopod cognition and behavior. implementing q-learning decision policies for adaptive behaviors. publication forthcoming.',
    lab: 'CARL lab @ UCI',
    tech: ['ros2', 'q-learning', 'python', 'reinforcement learning'],
    status: 'in progress',
    date: '2025-present',
    perms: 'drwxr-xr-x',
  },
];

export default function Research() {
  const [expanded, setExpanded] = useState(null);

  const handleClick = (slug) => {
    setExpanded(expanded === slug ? null : slug);
  };

  return (
    <div>
      <div className="prompt">
        <span className="p-user">vansh</span>
        <span className="p-sep">@</span>
        <span className="p-user">portfolio</span>
        <span className="p-sep">:</span>
        <span className="p-path">~/research</span>
        <span className="p-char">$</span>
        <span className="p-cmd">ls -la</span>
      </div>

      <div className="output">
        <div className="total-line">total {research.length}</div>
        {research.map((item, i) => (
          <motion.div
            key={item.slug}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04, duration: 0.2 }}
          >
            <div
              className="file-row"
              role="button"
              tabIndex={0}
              aria-expanded={expanded === item.slug}
              onClick={() => handleClick(item.slug)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleClick(item.slug);
                }
              }}
            >
              <span className="f-perms">{item.perms}</span>
              <span className="f-size">{item.status === 'in progress' ? 'WIP' : '--'}</span>
              <span className="f-date">{item.date}</span>
              <span className="f-name">{item.title}</span>
            </div>

            <AnimatePresence>
              {expanded === item.slug && (
                <motion.div
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.2 }}
                  style={{ overflow: 'hidden' }}
                >
                  <div className="prompt" style={{ marginTop: 16, marginBottom: 4 }}>
                    <span className="p-user">vansh</span>
                    <span className="p-sep">@</span>
                    <span className="p-user">portfolio</span>
                    <span className="p-sep">:</span>
                    <span className="p-path">~/research</span>
                    <span className="p-char">$</span>
                    <span className="p-cmd">cat {item.slug}</span>
                  </div>

                  <div className="project-detail">
                    <div className="content-title">{item.title}</div>
                    <div className="content-meta">
                      <span>{item.lab}</span>
                      <span className="sep">·</span>
                      <span>{item.date}</span>
                      <span className="sep">·</span>
                      <span>{item.status}</span>
                    </div>
                    <div className="project-desc" style={{ marginTop: 16 }}>
                      {item.description}
                    </div>
                    <div style={{ marginBottom: 12 }}>
                      {item.tech.map((t) => (
                        <span key={t} className="tech-tag">{t}</span>
                      ))}
                    </div>
                  </div>
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
